import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component, EventEmitter, Inject, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpService } from 'src/services/http.service';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {

  isSmallScreen$: Observable<boolean>;
  stepOne: UntypedFormGroup;
  stepTwo: UntypedFormGroup;
  stepThree: UntypedFormGroup;
  stepFour: UntypedFormGroup;
  //allFormIsValid: Array<boolean>;
  stepsValid: boolean[] = [false, false, false];
  @ViewChild(MatStepper) stepper: MatStepper;
  isLinearSteep: boolean = true;
  continueDataEvent: EventEmitter<any> = new EventEmitter<any>();
  continueRegister: boolean = false;

  constructor(
    private breakpoint: BreakpointObserver,
    private change: ChangeDetectorRef,
    private router: Router,
    private route: ActivatedRoute,
    private http: HttpService
  ) {

  }

  ngOnInit(): void {
    // this.stepsValid[0] = true;
    // this.stepsValid[1] = true;
    //this.stepsValid[2] = true;

    this.isSmallScreen$ = this.breakpoint
      .observe([Breakpoints.XSmall, Breakpoints.HandsetPortrait])
      .pipe(
        map(state => {
          return state.matches
        })
      )

    if (this.route.snapshot.queryParams.cpf) {
      const data = {
        cnpj: this.route.snapshot.queryParams.cpf
      };
      this.http.list('continue_registration', data)
        .subscribe(
          (result: any) => {

            if (result) {

              this.continueRegister = true;

              const filteredUserData = {}

              for (const key in result['user']) {
                const value = result['user'][key];
                if (value != 'undefined' && value != 'false') {
                  filteredUserData[key] = value;
                }
              }

              result['user'] = filteredUserData;
              this.continueDataEvent.emit(result);

            }

          }
        )
    }

  }

  public onStepOne(args) {

    this.stepOne = (args as UntypedFormGroup);
    this.change.detectChanges();

  }

  public onStepTwo(args) {

    this.stepTwo = (args as UntypedFormGroup);
    this.change.detectChanges();


  }

  public onStepThree(args) {

    this.stepThree = (args as UntypedFormGroup);
    this.change.detectChanges();

  }

  public onStepFour(args) {

    this.stepFour = (args as UntypedFormGroup);
    this.change.detectChanges();

  }

  public submitStepTwo() {

    this.stepsValid[1] = true;
    this.router.navigate(['/', 'register'], { queryParams: { ...this.route.snapshot.queryParams, valid: true } });

  }

  public isComplete() {
    return this.stepsValid.every(value => value === true);
  }

  public doneAll() {

    if (this.isComplete()) {
      alert('Cadastro concluido com sucesso');
      this.router.navigate(['/'])
    }

  }

  handleFinishSubmit(value: boolean) {
    this.stepsValid[2] = value;
    this.isComplete();
  }

}
